import { EventTypes } from 'redux-segment';

import { CHANGE_PAYMENT_TYPE } from 'actions/payment/feChangePaymentType.types';

const feChangePaymentType = ({ paymentType }) => ({
  type: CHANGE_PAYMENT_TYPE,
  paymentType,
  meta: { analytics: EventTypes.track },
});

export default feChangePaymentType;
